import * as React from 'react';
import { DefaultSortOrder, DomainNode } from 'ui/sort-order/types';
import styles from './sort-by-list.scss';
import { sortOrderType } from 'ui/sort-order/constants';
import { SortByListItem } from 'ui/sort-order/sort-by-list/sort-by-item/sort-by-item';
import { getNotSelectedOptions, sortDefaultSortOrder } from 'ui/sort-order/utils';

export interface SortByListProps {
  options: DomainNode[];
  translation: any;
  loadOptions: (query?: string) => void;
  sortOrderFields: DefaultSortOrder[];
  setSortOrderFields: React.Dispatch<React.SetStateAction<DefaultSortOrder[]>>;
}
export const SortByList = (props: SortByListProps) => {
  const { sortOrderFields, options, translation, loadOptions, setSortOrderFields } = props;

  const addNewSortField = (e: React.SyntheticEvent<any>) => {
    e.preventDefault();
    const maxOrderBySequence = sortOrderFields.length > 0 ? Math.max(...sortOrderFields.map((curr) => curr.orderBySequence)) : 0;
    const newSortArgument = {
      domainNode: { value: -1, description: '' },
      sortOrderType: sortOrderType.DESC,
      orderBySequence: maxOrderBySequence + 1
    };
    setSortOrderFields([...sortOrderFields, newSortArgument]);
  };

  const onMove = (value: number, type: number) => {
    setSortOrderFields(sortDefaultSortOrder(value, sortOrderFields, type));
  };

  const onSortOrderChange = (sortByItem: DefaultSortOrder) => {
    setSortOrderFields((prevFields) =>
      prevFields.map((element) =>
        element.orderBySequence === sortByItem.orderBySequence ? sortByItem : element
      )
    );
  };

  const onSortRemove = (index: number) => {
    const removedElement = sortOrderFields[index];
    const newOptions = sortOrderFields
      .filter((_, i) => i !== index)
      .map((element) => {
        if (element.orderBySequence > removedElement.orderBySequence) {
          return {
            ...element,
            orderBySequence: element.orderBySequence - 1
          };
        }
        return element;
      });

    setSortOrderFields(newOptions);
  };

  const handleNotSelectedOptions = (sortByItem: DefaultSortOrder): DomainNode[] => {
    return getNotSelectedOptions(
      sortByItem,
      sortOrderFields,
      options
    );
  };

  const orderBySequences = sortOrderFields.map((curr) => curr.orderBySequence);
  const hideAddSortParam = sortOrderFields.find((e) => e.domainNode.value === -1);
  const min = Math.min(...orderBySequences);
  const max = Math.max(...orderBySequences);
  const items = sortOrderFields?.sort((a, b) => a.orderBySequence - b.orderBySequence)
    ?.map((sortByItem, index) => <div key={index}>
      <SortByListItem
        onSortOrderChange={onSortOrderChange}
        onSortOrderRemove={onSortRemove}
        onMove={onMove}
        translation={translation}
        index={index}
        sortByItem={sortByItem}
        options={handleNotSelectedOptions(sortByItem)}
        loadOptions={loadOptions}
        minNumber={min}
        maxNumber={max}
      />
    </div>);

  return (<div>
    <div className={styles.sortByListItems}>
      {items}
    </div>
    {!hideAddSortParam ? <a href="#" className="ui-standalone-link" onClick={addNewSortField}>
      {`+ ${translation.sort_order_button_add_sort_param}`}
    </a> : null}
  </div>);
};
